import { React, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import HeaderPopup from "./HeaderPopup";
import logo from "../auth/assets/logo.png";

const Header = () => {
  const { email, logout, userRole } = useAuth();
  const [theme, setTheme] = useState("light");
  const [socketData, setsocketData] = useState("");
  const websocketUrl = `wss://api.dubaijewellerygroup.com/ws_monitor`;

  useEffect(() => {
    let ws = new WebSocket(websocketUrl);

    ws.onopen = () => console.log("WebSocket connection opened");

    ws.onmessage = (event) => {
      const data = event.data;
      setsocketData(extractStatus(data));
    };

    ws.onerror = (error) => console.error("WebSocket error:", error);

    // return () => {
    //   ws.close();
    // };

    const logoutTimer = setTimeout(() => {
      logout();
      // }, 30000);
    }, 600000); //10 mins

    return () => clearTimeout(logoutTimer);
  }, [logout, socketData, websocketUrl]);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-theme", savedTheme);
    setTheme(savedTheme);
  }, []);

  const extractStatus = (data) => {
    const parts = data.split(" ");
    return parts[parts.length - 1];
  };

  const changeTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", newTheme);
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  return (
    <div className="border-2 w-full flex px-4 bg-base-100">
      <div className="flex-1">
        <div className="flex row justify-between">
          <img className="ml-10 mt-2 mb-2 h-12" src={logo} alt="logo" />
          <h2 className=" text-gray-500 text-sm font-bold h-12 flex items-center justify-center mt-2 mr-20 mb-2">
            Status:&nbsp;&nbsp;{" "}
            <span
              className={
                socketData === "Online"
                  ? "text-green-500"
                  : socketData === "Offline"
                  ? "text-green-500"
                  : "text-blue-500"
              }
            >
              {socketData === "Online"
                ? "Online"
                : socketData === "Offline"
                ? "Offline"
                : "Checking Status"}
            </span>
          </h2>
        </div>
      </div>
      <div className="flex-none">
        <div className="dropdown dropdown-end">
          <div className="indicator mr-4">
            <label className="swap swap-rotate">
              <input
                type="checkbox"
                checked={theme === "dark"}
                onChange={changeTheme}
              />

              <svg
                className="swap-on h-8 w-8 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" />
              </svg>

              <svg
                className="swap-off h-8 w-8 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" />
              </svg>
            </label>
          </div>
        </div>
        <div className="dropdown dropdown-end">
          <div
            tabIndex={0}
            role="button"
            className="btn btn-ghost btn-circle avatar"
          >
            <div className="w-10 rounded-full p-2 bg-gray-500">
              <svg
                className="w-6 h-6 text-gray-800 dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeWidth="2"
                  d="M5 7h14M5 12h14M5 17h14"
                />
              </svg>
            </div>
          </div>
          <ul
            tabIndex={0}
            className="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-52 p-2 shadow"
          >
            <li>
              <a href="." className="justify-between">
                👋{email}
              </a>
            </li>
            {userRole && userRole === "Admin" ? (
              <li>
                <button
                  className="btn"
                  onClick={() =>
                    document.getElementById("my_modal_4").showModal()
                  }
                >
                  Brodcast manual rates
                </button>
              </li>
            ) : (
              ""
            )}

            <li>
              <Link to="/updatepassword">Change Password</Link>
            </li>
            <li>
              <a href="." onClick={logout}>
                Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
      <HeaderPopup />
    </div>
  );
};

export default Header;
